import React, { useEffect, useRef, useState } from "react";

export function PhotoScrollRow({ className, maxShift = 12 }) {
  const sectionRef = useRef(null);
  const row1Ref = useRef(null);
  const row2Ref = useRef(null);
  const [isInView, setIsInView] = useState(false);
  const rafId = useRef(null);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => setIsInView(entry.isIntersecting),
      { rootMargin: "10% 0px 10% 0px" },
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!isInView) return;

    const updatePositions = () => {
      rafId.current = null;
      const el = sectionRef.current;
      if (!el) return;

      const rect = el.getBoundingClientRect();
      const vh = window.innerHeight;

      const progress = Math.min(
        1,
        Math.max(0, (vh - rect.top) / (vh + rect.height)),
      );
      const shift = (progress - 0.5) * 2 * maxShift;

      if (row1Ref.current) {
        row1Ref.current.style.transform = `translateX(${shift}%)`;
      }
      if (row2Ref.current) {
        row2Ref.current.style.transform = `translateX(${-shift}%)`;
      }
    };

    const handleScroll = () => {
      if (rafId.current) return;
      rafId.current = requestAnimationFrame(updatePositions);
    };

    updatePositions();
    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("resize", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
      if (rafId.current) cancelAnimationFrame(rafId.current);
    };
  }, [isInView, maxShift]);

  return (
    <div className={`photo-scroll-row ${className ?? ""}`} ref={sectionRef}>
      <div className="psr-band psr-band-left">
        <img
          ref={row1Ref}
          className="psr-img"
          src="/img/graphic-photoscrollrow-1.webp"
          alt=""
        />
      </div>
      <div className="psr-band psr-band-right">
        <img
          ref={row2Ref}
          className="psr-img"
          src="/img/graphic-photoscrollrow-2.webp"
          alt=""
        />
      </div>
    </div>
  );
}
